import { Button } from '@cp/ds/src/components/button';
import { Stack } from '@cp/ds/src/components/stack';
import { useToast } from '@cp/shared/toast';
import { adminProcessingApi } from 'src/entities/processing';
import { DealProcessingStatus, ProcessingViewModel } from '@common/model/processing';
import { DealViewModel } from '@common/model/deal';
import { differenceInMinutes } from 'date-fns';
import { PropsWithChildren, useEffect, useState } from 'react';
import { useProcessingAndReviews } from '../processingAndReviews';

const getLeftMinutes = (date: Date) => {
  const diff = Math.max(0, 15 - differenceInMinutes(new Date(), date));
  return `0${diff}`.slice(-2);
};

export const ProcessingFooter = ({
  processing,
  deal,
  children,
}: PropsWithChildren<{ processing: ProcessingViewModel; deal: DealViewModel }>) => {
  const [leftMinutes, setLeftMinutes] = useState(getLeftMinutes(deal.createdAt));

  const toast = useToast();
  const { data } = useProcessingAndReviews();
  const [markAsProcessed, { isLoading }] = adminProcessingApi.endpoints.markAsProcessed.useMutation();

  const isWaiting = processing.status === DealProcessingStatus.Waiting;

  const handleSetProcessed = async () => {
    const result = await markAsProcessed(processing.id);

    if (result.error) {
      toast('error', result.error.message);
      return;
    }

    toast('success', 'Заказ был успешно отработан');
    data.refetch();
  };

  useEffect(() => {
    const leftMinutesIntrv = setInterval(() => {
      const lm = getLeftMinutes(deal.createdAt);
      if (+lm < 1) clearInterval(leftMinutesIntrv);
      setLeftMinutes(lm);
    }, 1000);

    return () => {
      clearInterval(leftMinutesIntrv);
    };
  }, []);

  return (
    <Stack pt={1.5} spacing={1}>
      <Stack alignItems="center" flexDirection="row" gap={1}>
        <Button disabled={!isWaiting} loading={isLoading} onClick={handleSetProcessed} size="extraSmall">
          Отработан
        </Button>
        {!isWaiting && `0:${leftMinutes}`}
        {children}
      </Stack>
    </Stack>
  );
};
